/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Permissions_NoteInputs */

const en_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If no groups are selected, all team members can access this folder.`)
};

const fr_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si aucun groupe n'est selectionne, tous les membres de l'equipe peuvent acceder a ce dossier.`)
};

const de_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn keine Gruppen ausgewählt sind, können alle Teammitglieder auf diesen Ordner zugreifen.`)
};

const it_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se non viene selezionato alcun gruppo, tutti i membri del team potranno accedere a questa cartella.`)
};

const ru_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если группы не выбраны, доступ к этой папке имеют все члены команды.`)
};

const es_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si no se selecciona ningún grupo, todos los miembros del equipo pueden acceder a esta carpeta.`)
};

const zh_cn2_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果没有选择任何组，则所有团队成员都可以访问此文件夹。`)
};

const ja_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループが選択されていない場合は、すべてのチーム メンバーがこのフォルダーにアクセスできます。`)
};

const hi_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि कोई समूह चयनित नहीं है, तो टीम के सभी सदस्य इस फ़ोल्डर तक पहुंच सकते हैं।`)
};

const pt_pt2_explorer_info_permissions_note = /** @type {(inputs: Explorer_Info_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se nenhum grupo for selecionado, todos os membros da equipe poderão acessar esta pasta.`)
};

/**
* | output |
* | --- |
* | "If no groups are selected, all team members can access this folder." |
*
* @param {Explorer_Info_Permissions_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_permissions_note = /** @type {((inputs?: Explorer_Info_Permissions_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Permissions_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_permissions_note(inputs)
	if (locale === "de") return de_explorer_info_permissions_note(inputs)
	if (locale === "it") return it_explorer_info_permissions_note(inputs)
	if (locale === "ru") return ru_explorer_info_permissions_note(inputs)
	if (locale === "es") return es_explorer_info_permissions_note(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_permissions_note(inputs)
	if (locale === "ja") return ja_explorer_info_permissions_note(inputs)
	if (locale === "hi") return hi_explorer_info_permissions_note(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_permissions_note(inputs)
	return en_explorer_info_permissions_note(inputs)
});